module.exports = __webpack_public_path__ + "img/symbol-quarter-center.3704f26c.png";